import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'gl',
    fullName: 'Galician',
    nativeName: 'Galego',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Algo incrible está chegando",
    landing_subtitle: "ArgVoid é un estudo de desenvolvemento de aplicacións e xogos. Estade atentos, pronto chegarán cousas novas!",
    select_language: "Seleccione Idioma",
    search_placeholder: "Buscar idiomas...",
    terms_title: "Condicións de servizo",
    policy_title: "Política de privacidade",
    cookies_title: "Política de cookies",
    terms_content: `
        <strong>1. Aceptación das Condicións</strong><br>
        Ao acceder a ArgVoid, acéptanse estas Condicións de servizo. Se non se aceptan estes termos, non se debería utilizar o servizo.<br><br>

        <strong>2. Uso da plataforma</strong><br>
        ArgVoid e as súas aplicacións ofrécense "tal cal" con fins informativos e creativos. O servizo só debe utilizarse con fins legais.<br><br>

        <strong>3. Conduta prohibida</strong><br>
        Está estrictamente prohibido explotar as vulnerabilidades do sitio, enviar correo lixo ou tentar acceder non autorizados á infraestrutura.<br><br>

        <strong>4. Exención de responsabilidade</strong><br>
        A plataforma e os servizos poden ser modificados en calquera momento sen previo aviso. Non se ofrece ningunha garantía sobre o tempo de actividade ou dispoñibilidade do servizo.
    `,
    policy_content: `
        <strong>1. Colección de información</strong><br>
        A plataforma non require autenticación de usuario nin creación de conta neste momento. Non se recolle activamente ningunha información de identificación persoal (como nomes ou enderezos de correo electrónico) dos visitantes.<br><br>

        <strong>2. Datos de uso</strong><br>
        Pódense recoller análises básicas e anónimas para comprender o tráfico do sitio e mellorar as aplicacións. Estes datos non están vinculados a identidades de usuarios individuais.<br><br>

        <strong>3. Servizos de terceiros</strong><br>
        Pódense utilizar provedores de terceiros para servizos de aloxamento e análise. As prácticas de privacidade destes respectivos provedores rexen os datos anónimos procesados na súa infraestrutura.<br><br>

        <strong>4. Seguridade de datos</strong><br>
        Aplícanse medidas de seguridade razoables para protexer a plataforma. Non obstante, ningún método de transmisión a través de Internet é totalmente seguro.<br><br>
    `,
    cookies_content: `
        <strong>1. Que son as cookies e o almacenamento local?</strong><br>
        As cookies e o almacenamento local do navegador son pequenos ficheiros de datos almacenados no dispositivo para lembrar as preferencias de configuración entre as visitas.<br><br>

        <strong>2. Finalidade de uso</strong><br>
        LocalStorage do navegador úsase estrictamente para gardar os axustes de configuración, como:<br>
        - Preferencias lingüísticas<br>
        - Configuración da interface de usuario (por exemplo, configuración de deseño ou tema) <br>
        - Caché da aplicación temporal<br><br>

        <strong>3. Sen seguimento</strong><br>
        As cookies e o almacenamento local non se utilizan con fins publicitarios ou de seguimento de terceiros. Todos os datos almacenados son estrictamente para a función principal da plataforma.<br><br>

        <strong>4. Control</strong><br>
        Os datos do navegador pódense borrar en calquera momento a través da configuración do navegador, que restablecerá calquera configuración local.
    `,
    cookie_consent_text: "Usamos cookies básicas para garantir que o sitio web funcione correctamente, como manter activa a súa sesión, gardar a súa preferencia de idioma e outras configuracións personalizadas.",
    read_policy: "Ler a política de cookies",
    support_title: "Contacte con Soporte",
    support_subject_label: "Asunto",
    support_message_label: "Mensaxe",
    support_submit_button: "Enviar mensaxe",
    support_hint: "Nota: Isto abrirá a túa aplicación de correo electrónico predeterminada para enviar a mensaxe.",
    support_success_msg: "Abrindo a túa aplicación de correo electrónico...",
    support_error_msg: "Produciuse un erro ao enviar a mensaxe. Téntao de novo máis tarde.",
    explorer_title: "Explorador",
    history_title: "Historia",
    animation_title: "Animación",
    config_title: "Configuración",
    tool_mouse: "Seleccionar (Ctrl+M)",
    tool_brush: "Pincel (Ctrl+B)",
    tool_brush_mode: "Alternar modo (sólido/claro)",
    tool_eraser: "Borrador (Ctrl+E)",
    tool_brush_size: "Axustar o tamaño do pincel",
    tool_bucket: "Encher (Ctrl+F)",
    tool_eyedropper: "Contagotas",
    tool_grid: "Reixa (Ctrl+Maiús+B)",
    tool_rotate: "Xirar (Ctrl+Maiús+R)",
    tool_flip_h: "Xire H (Ctrl+Maiús+H)",
    tool_flip_v: "Voltar V (Ctrl+Maiús+V)",
    tool_transpose: "Transpoñer (Ctrl+Maiús+T)",
    label_width: "Anchura",
    label_height: "Altura",
    label_frames: "Número de cadros",
    label_animation: "Estilo de animación",
    label_background_color: "Cor de fondo",
    label_interval: "Intervalo",
    tool_anim_config: "Configuración de animación",
    label_new_width: "Novo ancho",
    label_new_height: "Nova altura",
    label_apply: "Solicitar",
    label_colors: "Cores",
    label_size: "Tamaño",
    label_tolerance: "Tolerancia",
    val_horizontal: "Horizontal",
    val_vertical: "Vertical",
    val_sequence: "Secuencia",
    val_bounce: "Rebote",
    val_random: "Aleatorio",
    val_solid: "Sólido",
    val_clear: "Limpar",
    action_add_sheet: "Folla Nova",
    action_import: "Importar",
    action_export: "Exportar",
    action_sort_projects: "Ordenar",
    sort_date_old: "Primeiro máis vello",
    sort_date_new: "O máis novo primeiro",
    sort_name_az: "Nome (A-Z)",
    sort_name_za: "Nome (Z-A)",
    action_new_sprite: "Novo Sprite",
    action_new_project: "Novo Proxecto",
    modal_save_all_title: "Gardar todos os cambios",
    modal_save_all_desc: "Selecciona os recursos que queres gardar:",
    modal_save_selected: "Gardar seleccionados",
    action_saved: "Gardado",
    modal_create_sprite_title: "Crear un novo Sprite",
    modal_create_project_title: "Crear Novo Proxecto",
    modal_add_sheet_title: "Engadir nova folla",
    modal_rename_sheet_title: "Cambiar o nome da folla",
    modal_rename_sprite_title: "Cambia o nome de Sprite",
    modal_delete_sprite_title: "Eliminar Sprite",
    modal_delete_project_title: "Eliminar proxecto",
    modal_delete_sheet_title: "Eliminar folla",
    placeholder_sprite_name: "Nome",
    placeholder_project_name: "Nome",
    placeholder_sheet_name: "Nome",
    placeholder_new_name: "Novo Nome",
    action_create: "Crear",
    action_add: "Engadir",
    action_rename: "Cambiar o nome",
    action_duplicate: "Duplicar",
    action_delete: "Eliminar",
    action_cancel: "Cancelar",
    confirm_delete_sprite: "Estás seguro de que queres eliminar este sprite?",
    confirm_delete_project: "Estás seguro de que queres eliminar este proxecto? Eliminaranse todos os sprites.",
    confirm_delete_sheet: "Estás seguro de que queres eliminar esta folla?",
    err_select_sprite: "Selecciona primeiro un sprite.",
    err_select_project: "Seleccione primeiro un proxecto.",
    err_name_empty: "O nome non pode estar baleiro.",
    err_sprite_exists: "Xa existe un sprite con ese nome.",
    err_project_exists: "Xa existe un proxecto con ese nome.",
    err_no_content: "Non hai contido que gardar.",
    err_no_changes: "Non hai cambios que gardar.",
    err_delete_last_sheet: "Non se pode eliminar a última folla.",
    err_extract_frames: "Non se puido extraer ningún fotograma.",
    err_indexeddb: "Produciuse un erro ao gardar localmente. É posible que o teu navegador non admita IndexedDB.",
    msg_upload_success: "Carga correcta: {0}",
    msg_upload_failed: "Fallou a carga: {0}",
    msg_save_success: "Gardar correctamente.",
    msg_saving: "Gardando...",
    msg_multi_save_result: "Gardáronse {0} recursos. {1} fallos.",
    menu_title: "Menú",
    menu_save: "Gardar",
    menu_save_all: "Gardar todo",
    menu_support: "Contacte con Soporte",
    label_local_storage: "Almacenamento local",
    label_sign_in: "Iniciar sesión",
    modal_export_title: "Exportar Sprite",
    label_filename: "Nome do ficheiro",
    label_format: "Formato",
    action_export_confirm: "Exportar",
};

export default translations;
